import React from "react";

const ImageMobileMenu = () => {
	return (
		<svg
			className="image-mobile-menu"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				transform="translate(1 4)"
				fill="#2B3136"
				d="M0 14h22v2H0v-2zm0-7h22v2H0V7zm0-7h22v2H0V0z"
			/>
		</svg>
	);
};

export default ImageMobileMenu;
